export enum LocalStorageKey {
  TestAutostart = 'TestAutostart',

  MicSoundAmbientType = 'MicSoundAmbientType',
  MicSoundTypes = 'MicSoundTypes',
  MicSoundFrequencyOscillatorType = 'MicSoundFrequencyOscillatorType',
  MicSoundFrequencyFrequency = 'MicSoundFrequencyFrequency',

  MicSoundAmbientVolume = 'MicSoundAmbientVolume',
  MicSoundNoiseVolume = 'MicSoundNoiseVolume',
  MicSoundNotesVolume = 'MicSoundNotesVolume',
  MicSoundFrequencyVolume = 'MicSoundFrequencyVolume',
  MicSoundFrequenciesVolume = 'MicSoundFrequenciesVolume',
  MicSoundMusicVolume = 'MicSoundMusicVolume',
  MicSoundPlaybackVolume = 'MicSoundPlaybackVolume',
  MicSoundMusicType = 'MicSoundMusicType',
  MicSoundNoiseType = 'MicSoundNoiseType',
  MicSoundPlaybackDelay = 'MicSoundPlaybackDelay',
  MicSoundNotesFrequency = 'MicSoundNotesFrequency',

  MicRecordsVisualizationType = 'MicRecordsVisualizationType',

  WebcamToolbarDevicesCountShown = 'WebcamToolbarDevicesCountShown',
  WebcamTestFiltersConfig = 'WebcamTestFiltersConfig',

  WebcamTestMirrorView = 'WebcamTestMirrorView',

  WebcamTestGridEnabled = 'WebcamTestGridEnabled',
  WebcamTestGridColor = 'WebcamTestGridColor',
  WebcamTestGridPositions = 'WebcamTestGridPositions',

  Country = 'Country',
}
